const UZBEK_NAMES = {
  "Film & Animation": "Film va Animatsiya",
  "Autos & Vehicles": "Avto va Transport",
  "Music": "Musiqa",
  "Pets & Animals": "Uy hayvonlari",
  "Sports": "Sport",
  "Short Movies": "Qisqa filmlar",
  "Travel & Events": "Sayohat va Tadbirlar",
  "Gaming": "O'yinlar",
  "Videoblogging": "Videoblog",
  "People & Blogs": "Bloggerlar",
  "Comedy": "Komediya",
  "Entertainment": "Ko'ngil ochar",
  "News & Politics": "Yangiliklar va Siyosat",
  "Howto & Style": "Qo'llanmalar va Uslub",
  "Education": "Ta'lim",
  "Science & Technology": "Fan va Texnologiya",
  "Nonprofits & Activism": "Jamoat tashkilotlari",
  "Movies": "Filmlar",
  "Anime/Animation": "Anime",
  "Action/Adventure": "Jangari/Sarguzasht",
  "Classics": "Klassika",
  "Comedy (Movies)": "Komediya filmlari",
  "Documentary": "Hujjatli film",
  "Drama": "Drama",
  "Family": "Oilaviy",
  "Foreign": "Xorijiy",
  "Horror": "Qo'rqinchli",
  "Sci-Fi/Fantasy": "Fantastika",
  "Thriller": "Triller",
  "Shorts": "Shorts",
  "Shows": "Ko'rsatuvlar",
  "Trailers": "Treylerlar",
};

export default UZBEK_NAMES;
